import React, { useEffect, useState, useContext } from "react";
import { AppContext, DispatchContext } from '../AppContext';
import TitleBar from '../../src/components/titleBar';
import * as actions from "../actions/actions";
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/styles';
import Service from "../services/service";
import { config, timeConverter } from '../helpers/constants';
import IconButton from '@material-ui/core/IconButton';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import Button from '@material-ui/core/Button';
import DashboardChart from "../components/DashboardChart";
import ResultOverview from "../components/ResultOverview";
import DashboardCard from "../components/DashboardCard";
import VideoCard from "../components/VideoCard";
import { Link, Typography } from "@material-ui/core";
import SimpleTable from "../components/SimpleTable";
import { useParams } from "react-router-dom";
import IconLabel from '../components/IconLabel';



export default function DashboardComponent(props) {
    const useStyles = makeStyles(theme => ({
        root: {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column"
        },
        dashboard: {
            padding: 8,
            width: "100%",
            height: 0,
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            gridTemplateRows: "200px 200px 300px 200px",
            gridTemplateAreas: `
            "newPanel creditsPanel latestChecksPanel latestChecksPanel"
            "chartUsagePanel chartProjectPanel latestChecksPanel latestChecksPanel"
            "activitiesPanel activitiesPanel newsPanel newsPanel"
            "videoPanel videoPanel videoPanel videoPanel"
            `,
            gap: "8px 8px",
            overflow: "auto"
        },
        newPanel: { gridArea: "newPanel" },
        creditsPanel: { gridArea: "creditsPanel" },
        activitiesPanel: { gridArea: "activitiesPanel" },
        chartUsagePanel: { gridArea: "chartUsagePanel" },
        chartProjectPanel: { gridArea: "chartProjectPanel" },
        latestChecksPanel: { gridArea: "latestChecksPanel" },
        videoPanel: { gridArea: "videoPanel" },
        newsPanel: { gridArea: "newsPanel" },

        activityTable: {
            width: "100%",
            tableLayout: "fixed",
        },
        activityDate: {
            width: "130px",
            textAlign: "center"
        },
        activityType: {
            width: "120px",
            textAlign: "center"
        },
        activityTitle: {
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
        },
        activityResult: {
            width: "90px",
            textAlign: "center",
            position: "relative",
        },
        activityAction: {
            width: "50px",
            textAlign: "center"
        },
        checkByText: {
            textAlign: "center",
            padding: "10px"
        },
        tableRow: {
            "&:hover": {
                backgroundColor: '#eeeeee ',
            },
            height: "30px",
            borderTop: '1px solid #D3D3D3',
            "&:last-child": {
                borderBottom: '1px solid #D3D3D3',
            },
            "&:nth-child(even)": {
                backgroundColor: '#f3f3f3',
                "&:hover": {
                    backgroundColor: '#eeeeee ',
                },
            }
        },
        newsCard: {
            backgroundColor: '#eeeeee',
            marginBottom: 4
        },
        newsItem: {
            padding: "5px",
            cursor: "pointer",
            display: "flex"
        },
        newsItemLeftPart: {
            width: "80%",
            display: "inline-block",
        },
        newsItemRightPart: {
            width: "20%",
            display: "inline-block",
            textAlign: "center",
            position: "relative",
        },
        newsItemLeftTitle: {
            fontWeight: "600",
            color: "red"
        },
        newsItemLeftDate: {
            fontStyle: "italic",
            fontSize: "14px",
        },
        newsItemLeftContent: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            "-webkitLineClamp": "3",
            "-webkitBoxOrient": "vertical"
        },
        newsItemRightImage: {
            maxWidth: "85px",
            position: "absolute",
            top: "40%",
            left: "50%",
            width: "50%",
            margin: "-15% 0 0 -25%"
        },
    }));

    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);
    const classes = useStyles(state);
    const [chartDataByProject, setChartDataByProject] = useState({});
    const [chartDataByMonth, setChartDataByMonth] = useState({});
    const { module, productId } = useParams();

    const messageTypeStrings = {
        new_report: s.messageTypes.plagCheckDone,
        check_started: s.messageTypes.plagCheckStarted,
        new_plagiarism: s.messageTypes.newPlagiarism,
        page_added: s.messageTypes.textAdded,
        scan_aborted: s.messageTypes.scanAborted
    };


    useEffect(() => {
        if (document.documentElement.clientWidth < 1024) {
            dispatch(actions.setUI({ leftPanelVisible: false }));
        } else {
            dispatch(actions.setUI({ leftPanelVisible: true }));
        }

        // open dialogs in case requested by entered url /eg. /login or /register
        module && module == "user" && dispatch(actions.setUI({ profileDialogVisible: true }));
        module && module == "settings" && dispatch(actions.setUI({ settingsDialogVisible: true }));
        module && module == "shop" && dispatch(actions.setUI({ paymentDialogVisible: true }));
        productId && parseInt(productId) && dispatch(actions.setCheckoutDetails({ productId: parseInt(productId) }));

        loadReports();
        loadReportStaticsByProject();
        loadReportStaticsByMonth();
        loadMessages();
        loadUserInfo();

        if (window && window.location && state.ui && state.ui.pageName !== window.location.pathname) {
            dispatch(actions.navigate_to(window.location.pathname))
        }
    }, []);


    function loadUserInfo() {
        Service.getUserInfo().then(response => {
            if (response && response.success && response.data) {
                dispatch(actions.setUserDetails(response.data));
                displayWelcomeMessage(response.data);
            }
        });
    }

    function displayWelcomeMessage(data) {
        if (data.welcomeMessage) {
            dispatch(actions.openLogDialog({
                title: s.dashboard.welcomeMessageTitle,
                markdown: data.welcomeMessage,
                okLabel: s.common.readUnderstood,
                hideCancelLabel: true,
                onConfirm: () => {
                    Service.updateUserAttrib("MessageReadDate", Math.floor(Date.now() / 1000));
                }
            }));
        }        
    }

    

    function loadReports() {
        Service.getReports({ filters: { projectId: "", search: "", date: "", state: "1" }, sortby: "Scheduled", pageno: 1, sortdir: "desc", pagesize: 25 }).then(res => {
            if (res.success) {
                dispatch(actions.get_reports_dashboard(res || []))
            } else {
                dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
            }
        });
    }

    function loadReportStaticsByProject() {
        Service.getChartData(0).then(res => {
            if (res.success) {
                let sendData = {
                    labels: [],
                    data: []
                }
                if (res.data && res.data.length > 0) {
                    res.data.map((item) => {
                        sendData.data.push(item.ReportCount);
                        sendData.labels.push(item.ProjectName || s.noProject);
                        return true;
                    });
                    setChartDataByProject(sendData);
                    dispatch(actions.get_report_statistics_by_project(sendData || {}))
                }
            } else {
                dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
            }
        });
    }

    function loadReportStaticsByMonth() {
        Service.getChartData(1).then(res => {
            if (res.success) {
                let sendData = {
                    labels: [],
                    data: []
                }
                if (res.data && res.data.length > 0) {
                    res.data.map((item) => {
                        sendData.labels.push(s.dashboard.projectDateFormat.format(item.Month, item.Year));
                        sendData.data.push(item.ReportCount);
                        return true;
                    });
                    setChartDataByMonth(sendData);
                    dispatch(actions.get_report_statistics_by_month(sendData || {}))
                }
            } else {
                dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
            }
        });
    }

    function loadMessages() {
        Service.getMessages().then(res => {
            if (res.success) {
                dispatch(actions.set_message_list(res || []))
            } else {
                dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
            }
        });
    }

    const onSelectId = (reportID, e) => {
        dispatch(actions.navigate_to("/plagiarism/reports/" + reportID));
        dispatch(actions.change_report_card(reportID));
    }

    const handleClickCreditsButton = () => {
        dispatch(actions.openPaymentDialog(true));
    };

    const now = Math.floor(Date.now() / 1000);
    const license = state.user.license;

    const messageColumns = [
        { bodyStyles: { width: 125 }, value: (row) => timeConverter(row.Date, true, s.common.dateTimeFormat) },
        { bodyStyles: { width: 125 }, value: (row) => messageTypeStrings[row.Type] || row.Type },
        { accessor: "Text", value: (row) => row.LinkId ? <Link style={{ cursor: "pointer" }} onClick={() => {
            dispatch(actions.get_report([]))
            dispatch(actions.navigate_to(`/plagiarism/reports/${row.LinkId ? row.LinkId : ''}`))
        }}>{row.Text}</Link> : row.Text},
    ];

    const reportsColumns = [
        { bodyStyles: { width: 125 }, value: (row) => timeConverter(row.Scheduled, true, s.common.dateTimeFormat) },
        { accessor: "Name", value: (row) => <Link style={{ cursor: "pointer" }} onClick={() => onSelectId(row.Id)}>{row.Name}</Link> },
        { bodyStyles: { width: 80 }, value: (row) => <ResultOverview value={row.ResultPercent} /> },
    ];
    return (
        <div className={classes.root}>
            <div style={{ display: "none", flex: "0 0 auto" }}>
                <TitleBar title={s.welcome} type="Dashboard" />
            </div>
            <div className={classes.dashboard} style={{ flex: "1 1 auto" }}>
                <div className={classes.newPanel}>
                    <DashboardCard rows={6} title={s.NewPlagCheck} action={<Button variant="contained" color="primary" onClick={() => dispatch(actions.navigate_to("/plagiarism/new"))}>{s.NewPlagCheck}</Button>} link={<IconButton onClick={() => dispatch(actions.navigate_to("/plagiarism/new"))} size="small" ><OpenInNewOutlinedIcon /></IconButton>}>
                        <Typography align="center">{s.dashboard.startNewCheckText}</Typography>
                    </DashboardCard>
                </div>
                <div className={classes.creditsPanel}>
                    <DashboardCard rows={6} title={s.dashboard.scanCredits} action={(!license.code || (license.remaining != -1)) && <Button variant="contained" color="primary" onClick={handleClickCreditsButton}>{s.dashboard.recharge}</Button>} link={<IconButton onClick={handleClickCreditsButton} size="small" ><OpenInNewOutlinedIcon /></IconButton>}>
                        <Typography align="center">{s.dashboard.prepaidCredits.format(state.user.credits)}</Typography>
                        {license.code &&
                            <>
                                <Typography align="center">{s.dashboard.licenseCredits.format(license.remaining == -1 ? s.dashboard.unlimited : license.remaining)}</Typography>
                                {state.user.logo ?
                                    <img style={{ marginTop: 8 }} className={classes.logo} src={config.backendUrl + state.user.logo} alt="logo" /> :
                                    <Typography style={{ marginTop: 8 }} variant="body2" color="secondary" align="center">{license.type == 1 ? s.dashboard.educationalLicense : s.dashboard.volumeLicense} {license.licensee}</Typography>
                                }
                                {false && license.valid && license.renewal && <Typography variant="body2" color="secondary" align="center">{s.dashboard.licenseRenewal.format(timeConverter(license.renewal, null, s.common.dateFormat))}</Typography>}
                                {false && license.valid && !license.renewal && <Typography variant="body2" color="secondary" align="center">{s.dashboard.licenseValidUntil.format(timeConverter(license.validTo, null, s.common.dateFormat))}</Typography>}
                                {!license.valid && (license.validFrom > now) && <Typography variant="body2" color="error" align="center">{s.dashboard.licenseValidFrom.format(timeConverter(license.validFrom, null, s.common.dateFormat))}</Typography>}
                                {!license.valid && (license.validTo < now) && <Typography variant="body2" color="error" align="center">{s.dashboard.licenseExpired}</Typography>}
                                {false && !license.paid && <Typography variant="body2" color="error" align="center">{s.dashboard.licenseNotPaid}</Typography>}
                            </>
                        }
                    </DashboardCard>
                </div>
                <div className={classes.chartUsagePanel}>
                    <DashboardCard title={s.dashboard.usageStats}>
                        {chartDataByMonth && chartDataByMonth.data && chartDataByMonth.data.length > 0 ?
                            <DashboardChart displayLegend={false} labels={chartDataByMonth.labels} type={"bar"} chartData={chartDataByMonth} /> :
                            <IconLabel spacing={16} centered label={s.dashboard.noStatistics} />}
                    </DashboardCard>
                </div>
                <div className={classes.chartProjectsPanel}>
                    <DashboardCard title={s.dashboard.projectStats}>
                        {chartDataByProject && chartDataByProject.data && chartDataByProject.data.length > 0 ?
                            <DashboardChart displayLegend={false} legendPosition="bottom" labels={chartDataByProject.labels} type={"pie"} chartData={chartDataByProject} /> :
                            <IconLabel spacing={16} centered label={s.dashboard.noStatistics} />}
                    </DashboardCard>
                </div>
                <div className={classes.videoPanel}>
                    <DashboardCard title={s.dashboard.videoTutorials} direction="row" align="flex-start">
                        <VideoCard title="Rundgang durch PlagAware" subtitle="Die wichtigsten Funktionen kurz erklärt" embedId="AvJE5RAg8sg" />
                        <VideoCard title="Weitere Titel..." subtitle="...sind gerade in Vorbereitung"  />

                        {false && <IconLabel centered spacing={32} label={s.dashboard.noVideos} />}
                    </DashboardCard>
                </div>
                <div className={classes.activitiesPanel}>
                    <DashboardCard justify="start" title={s.dashboard.recentMessages} rows={13}>
                        {state.messageList.length > 0 ?
                            <SimpleTable data={state.messageList} columns={messageColumns} /> :
                            <IconLabel spacing={32} centered label={s.dashboard.noActivities} />}
                    </DashboardCard>
                </div>
                <div className={classes.latestChecksPanel}>
                    <DashboardCard rows={13} justify="start" title={s.dashboard.latestChecks} link={<IconButton onClick={() => dispatch(actions.navigate_to("/plagiarism/reports"))} size="small" > <OpenInNewOutlinedIcon /> </IconButton>} >
                        {state.reportsDashboard.length > 0 ?
                            <SimpleTable data={state.reportsDashboard} columns={reportsColumns} /> :
                            <IconLabel spacing={32} centered label={s.dashboard.noPlagChecksPerformed} />}
                    </DashboardCard>
                </div>
                <div className={classes.newsPanel}>
                    <DashboardCard justify="start" rows={13} title={s.dashboard.news}>
                        <div className={classes.newsCardContent}>
                            {state.news.map((newsitem, i) => (
                                <Card className={classes.newsCard} key={i.toString()} onClick={() => dispatch(actions.navigate_to(`${config.backendUrl}${newsitem.LinkUrl}`))}>
                                    <div className={classes.newsItem}>
                                        <div className={classes.newsItemRightPart}>
                                            <img className={classes.newsItemRightImage} src={`${config.backendUrl}${newsitem.Image}`} alt="news" />
                                        </div>
                                        <div className={classes.newsItemLeftPart}>
                                            <Typography>{newsitem.Title}</Typography>
                                            <Typography variant="caption" color="secondary">{newsitem.Date}</Typography>
                                            <Typography className={classes.newsItemLeftContent} variant="body2">{newsitem.Text}</Typography>
                                        </div>
                                    </div>
                                </Card>
                            ))}
                        </div>
                    </DashboardCard>
                </div>
            </div>
        </div>
    );
}